import type { ScriptLine } from "../../coldcompute";

// Caption lines are SCENE-LOCAL (fromSec resets to 0 inside each scene's <Sequence>).
// Every claim grounded in the real 2026-07-04 incident: Supabase capacity incident
// starving smaller compute in ap-south-1, a 1GB Micro returning 57P03, Cloudflare 522
// on login, a crashed sync holding sync_locks (job 400b6b62, status=processing), the
// 8-to-120-min recovery dead zone, and the acquire-time heartbeat lock-steal fix
// (stealLockIfHolderDead) that fails closed. See EAKC
// docs/2026-07-05-orphan-lock-recovery-architecture.md.

export const HOOK: ScriptLine[] = [
  { scene: "hook", fromSec: 0.3, holdSec: 4.4, caption: "My database didn't crash — it vanished, mid-sync, and I couldn't even log in. Everything I'd actually built was fine." },
];

export const NOTYOU: ScriptLine[] = [
  { scene: "notyou", fromSec: 0.4, holdSec: 5.5, caption: "The login page redirected to a Cloudflare 522 — my managed Postgres simply wasn't answering." },
  { scene: "notyou", fromSec: 6.2, holdSec: 6, caption: "Not my bug: a platform-wide capacity incident was starving small database instances — and mine was the smallest tier, 1 GB of RAM." },
  { scene: "notyou", fromSec: 12.5, holdSec: 5, caption: "Postgres itself returned 57P03 — 'the database system is not accepting connections'." },
];

export const STUCK: ScriptLine[] = [
  { scene: "stuck", fromSec: 0.4, holdSec: 5.5, caption: "Hours later it recovered — a direct connection answered in 145 milliseconds. Healthy again." },
  { scene: "stuck", fromSec: 6.2, holdSec: 5, caption: "But every new sync I triggered just sat there: Processing… 0%. Forever." },
  { scene: "stuck", fromSec: 11.5, holdSec: 4, caption: "The database was fine. Something else was jammed." },
];

export const ZOMBIE: ScriptLine[] = [
  { scene: "zombie", fromSec: 0.4, holdSec: 6, caption: "When the instance died, a sync was running — and it held a lock: a coat-check ticket that says 'only I may run right now'." },
  { scene: "zombie", fromSec: 6.6, holdSec: 6, caption: "The process was killed before it could hand the ticket back. The lock stayed — owned by a job that no longer exists." },
  { scene: "zombie", fromSec: 13, holdSec: 4.5, caption: "A zombie: marked 'processing' forever, blocking every sync queued behind it." },
];

export const DEADZONE: ScriptLine[] = [
  { scene: "deadzone", fromSec: 0.4, holdSec: 5.5, caption: "The twist: my system already had three ways to clean up a dead lock." },
  { scene: "deadzone", fromSec: 6.1, holdSec: 5.5, caption: "One runs on restart — an 8-minute heartbeat check. But nothing restarted, so it never fired." },
  { scene: "deadzone", fromSec: 11.8, holdSec: 5.5, caption: "One runs on a 120-minute timer. But my job was only 105 minutes old — not yet 'stuck'." },
  { scene: "deadzone", fromSec: 17.5, holdSec: 4, caption: "A dead lock, sitting in a gap with no on-demand rescue: the 8-to-120-minute dead zone." },
];

export const FIX: ScriptLine[] = [
  { scene: "fix", fromSec: 0.4, holdSec: 5.5, caption: "The missing idea: recover the lock when a new sync actually needs it — not on a timer." },
  { scene: "fix", fromSec: 6.1, holdSec: 6, caption: "When a sync is blocked, check the holder's heartbeat. Silent longer than 8 minutes? The holder is dead — steal the lock and go." },
  { scene: "fix", fromSec: 12.4, holdSec: 5.5, caption: "A blocked sync now heals itself in under 8 minutes, on demand. No restart, no two-hour wait." },
];

export const LANDMINE: ScriptLine[] = [
  { scene: "landmine", fromSec: 0.4, holdSec: 6, caption: "The first version had a trap. A sync that JUST started hasn't sent its first heartbeat — its timestamps are empty." },
  { scene: "landmine", fromSec: 6.6, holdSec: 6, caption: "The code read 'no heartbeat' as 'dead' and stole the lock from a LIVING sync — two syncs at once, the exact out-of-memory crash the lock prevents." },
  { scene: "landmine", fromSec: 13, holdSec: 4.5, caption: "An adversarial review caught it. The rule for anything safety-critical: when unsure it's dead, do nothing. Fail closed." },
];

export const LAYERS: ScriptLine[] = [
  { scene: "layers", fromSec: 0.4, holdSec: 6.5, caption: "The full picture now: five layers of recovery — from the instant release on the happy path to the on-demand steal that closes the dead zone." },
];

export const OUTRO: ScriptLine[] = [
  { scene: "outro", fromSec: 0.4, holdSec: 5, caption: "A lock without a heartbeat is a landmine. Recover on demand, not on a timer." },
  { scene: "outro", fromSec: 5.6, holdSec: 3.6, caption: "And when in doubt — fail closed." },
];

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
